import { useEffect, useState } from "react";
import { clamp } from "./logic";

interface StepperProps {
  value: number;
  min: number;
  max: number;
  step?: number;
  onChange: (value: number) => void;
  label: string;
  unit?: string;
  /** campo largo (coluna lateral) com valor editável */
  wide?: boolean;
}

export default function Stepper({
  value,
  min,
  max,
  step = 1,
  onChange,
  label,
  unit,
  wide = false,
}: StepperProps) {
  const [draft, setDraft] = useState(String(value));

  useEffect(() => setDraft(String(value)), [value]);

  const commit = () => {
    const parsed = parseInt(draft, 10);
    const next = Number.isNaN(parsed) ? value : clamp(parsed, min, max);
    setDraft(String(next));
    if (next !== value) onChange(next);
  };

  return (
    <div
      className={`qz-stepper ${wide ? "qz-stepper-wide" : ""}`}
      role="group"
      aria-label={label}
    >
      <button
        type="button"
        aria-label={`Diminuir ${label.toLowerCase()}`}
        disabled={value <= min}
        onClick={() => onChange(clamp(value - step, min, max))}
      >
        −
      </button>
      {wide ? (
        <>
          <input
            className="qz-stepper-value"
            inputMode="numeric"
            aria-label={label}
            value={draft}
            onChange={(e) => setDraft(e.target.value.replace(/\D/g, ""))}
            onFocus={(e) => e.target.select()}
            onBlur={commit}
            onKeyDown={(e) => e.key === "Enter" && (e.target as HTMLInputElement).blur()}
          />
          {unit && (
            <span aria-hidden style={{ marginLeft: -10, marginRight: 14, fontWeight: 700 }}>
              {unit}
            </span>
          )}
        </>
      ) : (
        <span className="qz-stepper-value" aria-live="polite">
          {value}
        </span>
      )}
      <button
        type="button"
        aria-label={`Aumentar ${label.toLowerCase()}`}
        disabled={value >= max}
        onClick={() => onChange(clamp(value + step, min, max))}
      >
        +
      </button>
    </div>
  );
}
